import { AppMobile } from './app.mobile'
import { AppDesktop } from './app.desktop'
import { useIsDesktopSize } from '$common/react-hooks/layout'

export function App() {
  const isDesktop = useIsDesktopSize()

  //TODO: Implement mobile->desktop | desktop->mobile transition in router's state. but for now, reloading window is sufficient
  return isDesktop ? <AppDesktop /> : <AppMobile />
}
